import { DateTime } from 'infras/datetime';

export const getMiddleWeekDay = (startWeekDay: number) => {
  return startWeekDay < 4 ? startWeekDay + 3 : startWeekDay - 4;
};

export const isLeftDay = (
  targetDate: Date | undefined | null,
  weekMiddleDay: number,
) => {
  if (!targetDate) return false;

  const offset = 3 - weekMiddleDay;
  const normalizedWeekMiddleDay = weekMiddleDay + offset;

  let normalizedWeekday = (targetDate.getDay() + offset) % 7;
  if (normalizedWeekday < 0) {
    normalizedWeekday += 7;
  }

  return normalizedWeekday > normalizedWeekMiddleDay;
};

export const getWeekStartedAt = (date: DateTime, startWeekDay: number) => {
  const startWeekDayForLuxon = startWeekDay === 0 ? 7 : startWeekDay;
  return date.weekday === startWeekDayForLuxon
    ? date.startOf('day')
    : date.startOf('day').plus({
        day: (startWeekDayForLuxon - date.weekday - 7) % 7,
      });
};
